import { JSX, useEffect, useMemo, useState } from "react";

import { Box, CssBaseline } from "@mui/material";

import { ReactComponent as IconLogo } from "../../assets/logosSvg/logoEasyBI.svg";
import {
  Outlet,
  useLoaderData,
  useLocation,
  useNavigation,
} from "react-router-dom";
import TopBar from "../../componentes/topBar";
import SideBar from "../../componentes/sideBar";
import { Socket } from "socket.io-client";

import { usePages } from "../../context/pageContext";

export interface LayoutProps {
  colorMode: boolean;
  setColorMode: React.Dispatch<React.SetStateAction<boolean>>;
  socket: Socket;
}

function Layout(params: LayoutProps): JSX.Element {
  const { colorMode, setColorMode, socket } = params;
  const navigation = useNavigation();

  const [openRightBar, setOpenRightBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [link, setLink] = useState("");
  const [pageConfig, setPageConfig] = useState(false); // armazena se a pina atual é a configuração
  const [hideSideBar, setHideSideBar] = useState<boolean>(false);
  const [hideTopBar, setHideTopBar] = useState<boolean>(false);
  const [isAutoRefresh, setIsAutoRefresh] = useState<boolean>(false);
  const location = useLocation();

  const { pages, setPages } = usePages();
  const paginasLoader = useLoaderData();

  const rightBarPages = useMemo(() => {
    return (pages ?? []).filter((page) => {
      return page.status === 1;
    });
  }, [pages]);
  useEffect(() => {
    if (paginasLoader) {
      setPages(paginasLoader);
    }
  }, [paginasLoader]);

  const styles = {
    containerLayout: {
      display: "flex",
      width: "100vw",
      height: "100vh",
      overflowY: "auto",
      overflowX: "hidden",
    },
    containerBody: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "fit-content",
      minWidth: "350px",
    },
    containerOutlet: {
      flexGrow: 1,
      // padding: 3,
      height: "fit-content",
      width: "100%",
      gap: 2,
      minWidth: "calc(100vw - 31a0px)",
    },
    titlePage: {
      flexGrow: 1,
      fontWeight: 400,
      fontSize: "1.25rem",
      marginX: 1,
      mt: 1,
      mb: 2,
    },
  };

  const rightBarPagesConfig = [
    {
      id: "1",
      title: "Administração",
      path: "/configuracoes/administracao",
      cardsGraphics: [],
      type: "FILHO" as const,
      status: 1,
      usePath: true,
    },
    {
      id: "2",
      title: "Páginas",
      path: "/configuracoes/paginas",
      cardsGraphics: [],
      type: "FILHO" as const,
      status: 1,
      usePath: true,
    },
    {
      id: "3",
      title: "Filtros",
      path: "/configuracoes/filtros",
      cardsGraphics: [],
      type: "FILHO" as const,
      status: 1,
      usePath: true,
    },
    {
      id: "4",
      title: "Data Source",
      path: "/configuracoes/datasource",
      cardsGraphics: [],
      type: "FILHO" as const,
      status: 1,
      usePath: true,
    },
  ];

  useEffect(() => {
    setPageConfig(location.pathname.includes("/configuracoes"));
  }, [location.pathname]);

  useEffect(() => {
    setHideSideBar(false);
  }, [pageConfig]);
  return (
    <Box display={"flex"}>
      <CssBaseline />

      <Box sx={styles.containerLayout}>
        {!hideSideBar && (
          <SideBar
            // items={pageConfig ? rightBarPagesConfig : rightBarPages}
            paginas={pageConfig ? rightBarPagesConfig : rightBarPages || []}
            // title="Navegação"
            openRightBar={true}
            setOpenRightBar={setOpenRightBar}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            iconLogo={<IconLogo />}
            titlePage={titlePage}
            setTitlePage={setTitlePage}
            link={link}
            setLink={setLink}
            pageConfig={pageConfig}
            hideSideBar={hideSideBar}
            hideTopBar={hideTopBar}
            setHideSideBar={setHideSideBar}
            setHideTopBar={setHideTopBar}
          />
        )}

        <Box sx={styles.containerBody}>
          {!hideTopBar && (
            <TopBar
              setOpenDrawer={setOpenDrawer}
              setOpenRightBar={setOpenRightBar}
              iconLogo={<IconLogo />}
              link={"/homeIn"}
              socket={socket}
              colorMode={colorMode}
              setColorMode={setColorMode}
              openRightBar={openRightBar}
            />
          )}
          <Box component="main" sx={styles.containerOutlet}>
            <Outlet
              context={{
                setTitlePage,
                hideSideBar,
                setHideSideBar,
                hideTopBar,
                setHideTopBar,
                setPages,
                pages,
                isAutoRefresh,
                setIsAutoRefresh,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Layout;
